__turbopack_context__.v({
  "nc-loop-dots-3-anim": "global-loading-module-scss-module__c0bX_G__nc-loop-dots-3-anim",
  "root": "global-loading-module-scss-module__c0bX_G__root",
});
